// extracted by mini-css-extract-plugin
export default {"logoLink":"G4fLCelEGO+y9AM2BEcxHQ==","logoImage":"rU82BRFRRJtwZKrUdHGY-w==","logoImageHeader":"tq9bUCTp73-Eon7ieDDWNA==","logoImageFooter":"_2Ft5uDuA8VNuA5cxdmdDGw=="};